import { render, staticRenderFns } from "./calibration.vue?vue&type=template&id=d1024778&scoped=true&"
import script from "./calibration.vue?vue&type=script&lang=ts&"
export * from "./calibration.vue?vue&type=script&lang=ts&"
import style0 from "./calibration.vue?vue&type=style&index=0&id=d1024778&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1024778",
  null
  
)

export default component.exports